import { HttpErrorResponse } from "@angular/common/http";
import { forNamespace } from "ngrx-action-bundles";
import { props } from "@ngrx/store";
import {
  IMeetingRoomKioskBookingCreationData,
  IMeetingRoomKioskData,
  IMeetingRoomKioskEventDetailsData,
} from "../models/kiosk.model";

const factory = forNamespace("[MEETING-ROOMS-KIOSK]");

export const loadKioskModeBundle = factory.asyncAction(
  "loadKioskMode",
  props<{ roomId: string }>(),
  props<{ data: IMeetingRoomKioskData }>(),
  props<{ error: HttpErrorResponse }>(),
);

export const createBookingBundle = factory.asyncAction(
  "createBooking",
  props<{ roomId: string; data: IMeetingRoomKioskBookingCreationData }>(),
  props<{ booking: string }>(),
  props<{ error: HttpErrorResponse }>(),
);

export const checkInBookingBundle = factory.asyncAction(
  "checkInBooking",
  props<{ roomId: string; eventId: string }>(),
  props<{ booking: string }>(),
  props<{ error: HttpErrorResponse }>(),
);

export const finishBookingBundle = factory.asyncAction(
  "finishBooking",
  props<{ roomId: string; eventId: string; endTime: string }>(),
  undefined,
  props<{ error: HttpErrorResponse }>(),
);

export const loadEventDetailsBundle = factory.asyncActionWithCleanup(
  "loadEventDetails",
  props<{ roomId: string; eventId: string }>(),
  props<{ eventDetails: IMeetingRoomKioskEventDetailsData }>(),
  props<{ error: HttpErrorResponse }>(),
);

export const exitKioskModeBundle = factory.asyncAction(
  "exitKioskMode",
  props<{ roomId: string }>(),
  undefined,
  props<{ error: HttpErrorResponse }>(),
);

export const bundles = [
  loadKioskModeBundle,
  createBookingBundle,
  checkInBookingBundle,
  finishBookingBundle,
  loadEventDetailsBundle,
  exitKioskModeBundle,
];
